/**
 * @fileoverview POSTWS handler for the "/engagement/api/segment_cohorts/preview_sql" endpoint
 *
 * Used to execute a "Query Preview" from sql segment extensions
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { engagementApiSegmentCohortsPreviewSql } from "./constants";
import type {
  PostwsEngagementApiSegmentCohortsPreviewSqlPayload,
  PostwsEngagementApiSegmentCohortsPreviewSqlProps,
} from "./types";
import { isSegmentCohortsExecuteSqlPreviewResult } from "./validators";

const ONE_MINUTE = 60000;

export const segmentCohortsPreviewSql = reactQueryPostWebsocketAdapter(
  engagementApiSegmentCohortsPreviewSql,
  async (
    signal,
    {
      timeout = ONE_MINUTE,
      jobToken,
      yDays,
      startDate,
      endDate,
      dateRangeType,
      formType,
      dataWarehouseConfigId,
      ...props
    }: PostwsEngagementApiSegmentCohortsPreviewSqlProps
  ): Promise<{}> => {
    const payload: PostwsEngagementApiSegmentCohortsPreviewSqlPayload = {
      ...props,
      timeout,
      job_token: jobToken,
      y_days: yDays,
      start_date: startDate,
      end_date: endDate,
      date_range_type: dateRangeType,
      type: formType,
      data_warehouse_config_id: dataWarehouseConfigId,
    };

    return fetch("/engagement/api/segment_cohorts/preview_sql", "POST", payload, { signal });
  },
  isSegmentCohortsExecuteSqlPreviewResult
);
